const API = (import.meta.env.VITE_API_URL as string | undefined) ?? '';

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string | undefined,
    message: string,
    public details?: unknown,
  ) {
    super(message);
  }
}

export const api = async <T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> => {
  const headers = new Headers(init.headers ?? {});
  if (init.body && !(init.body instanceof FormData) && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  const res = await fetch(`${API}${path}`, {
    credentials: 'include',
    ...init,
    headers,
  });
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  const parsed = text ? JSON.parse(text) : undefined;
  if (!res.ok) {
    throw new ApiError(
      res.status,
      parsed?.code,
      parsed?.error ?? `Request failed (${res.status})`,
      parsed?.details,
    );
  }
  return parsed as T;
};

export const apiRaw = async (path: string, init: RequestInit = {}) => {
  const res = await fetch(`${API}${path}`, { credentials: 'include', ...init });
  if (!res.ok) throw new ApiError(res.status, undefined, `Request failed (${res.status})`);
  return res;
};

export const apiUrl = (path: string) => `${API}${path}`;
